import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import constantRoutes from '@/router/constantRoutes';
// import { fetchPermissionList } from 'api/user'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(permissionList, route) {
  if (route.meta && route.meta.permission) {
    return permissionList.some(function (item) {
      return route.meta.permission.includes(item);
    });
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, permissionList) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasPermission(permissionList, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissionList);
      }
      res.push(tmp);
    }
  });
  return res;
}
var state = {
  permissionList: [],
  routes: [],
  // menu from this
  addRoutes: [],
  accountTypes: [],
  currentAccount: '',
  accessRecord: []
};
var mutations = {
  SET_PERMISSION_LIST: function SET_PERMISSION_LIST(state, permissionList) {
    state.permissionList = permissionList;
  },
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  SET_ACCOUNT_TYPES: function SET_ACCOUNT_TYPES(state, accountTypes) {
    state.accountTypes = accountTypes;
  },
  SET_ACCOUNT: function SET_ACCOUNT(state, account) {
    state.currentAccount = account;
  },
  SET_ACCESS_RECORD: function SET_ACCESS_RECORD(state, accessRecord) {
    state.accessRecord = accessRecord;
  }
};
var actions = {
  setPermissionList: function setPermissionList(_ref, permissionList) {
    var commit = _ref.commit;
    commit('SET_PERMISSION_LIST', permissionList);
  },
  setRoutes: function setRoutes(_ref2, accessRoutes) {
    var commit = _ref2.commit;
    commit('SET_ROUTES', accessRoutes);
  },
  setAccountTypes: function setAccountTypes(_ref3, accountTypes) {
    var commit = _ref3.commit;
    commit('SET_ACCOUNT_TYPES', accountTypes);
  },
  setAccessRecord: function setAccessRecord(_ref4, accessRecord) {
    var commit = _ref4.commit;
    commit('SET_ACCESS_RECORD', accessRecord);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};